import { Avatar, Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import { getUser } from '@/util/getUser';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@/context/context';

export const ProfileSection = ({ onNavigate }: { onNavigate?: () => void } = {}) => {
  const user = getUser();
  const navigate = useNavigate();
  const { setUser } = useAppContext() || { setUser: () => {} };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleLogout = () => {
    window.localStorage.removeItem('reshet-token');
    setUser(undefined);
    navigate('/login');
    onNavigate?.();
  };

  const handleEdit = () => {
    navigate('/details');
    onNavigate?.();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        ...(isMobile && {
          color: 'common.white'
        })
      }}
    >
      <Avatar
        alt={user?.nickName || user?.firstName || user?.lastName}
        src={user?.profileImage}
        sx={{
          width: 40,
          height: 40,
          mb: 1
        }}
      >
        {(user?.firstName || '').charAt(0) + (user?.lastName || '').charAt(0)}
      </Avatar>

      <StaffMemberAndInstitutionName isMobile={isMobile} />
      {/* Edit/Logout buttons */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: 1
        }}
      >
        <IconButton size="small" onClick={handleEdit}>
          <EditIcon sx={{ width: 16, height: 17, color: isMobile ? 'common.white' : 'rgba(0, 0, 0, 0.56)' }} />
        </IconButton>
        <IconButton size="small" onClick={handleLogout}>
          <LogoutIcon sx={{ width: 16, height: 17, color: isMobile ? 'common.white' : 'rgba(0, 0, 0, 0.56)' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export const StaffMemberAndInstitutionName = ({
  onClick,
  isMobile = false
}: {
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  isMobile?: boolean;
}) => {
  const user = getUser();
  return (
    <Box onClick={onClick} sx={{ textAlign: 'center' }}>
      <Typography
        variant="caption"
        sx={{
          fontSize: 10,
          lineHeight: '150%',
          color: isMobile ? 'common.white' : 'rgba(0, 0, 0, 0.56)',
          display: 'block'
        }}
      >
        {user?.nickName || user?.firstName || user?.lastName}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          fontSize: 10,
          lineHeight: '150%',
          color: 'common.white',
          display: 'block'
        }}
      >
        {user?.institutionName}
      </Typography>
    </Box>
  );
};

export default ProfileSection;
